<template>
  <div>
    <md-toolbar>
      <h2 class="md-title" style="flex: 1">Tickets</h2>

      <md-menu md-align-trigger>
        <!-- <router-link class="md-button" to="/dashboard">
          <md-icon>dashboard</md-icon>
          <md-tooltip>Dashboard</md-tooltip>
        </router-link> -->
        <md-button md-menu-trigger class="md-icon-button">
          <md-icon>arrow_drop_down</md-icon>
        </md-button>

        <md-menu-content>
          <md-menu-item @click="logout">Logout</md-menu-item>
        </md-menu-content>
      </md-menu>

    </md-toolbar>
    <div class="space"></div>
    <md-layout mdAlign="center" mdGutter="16">
      <md-layout mdFlex="75">
        <md-layout mdColumn>
          <md-layout mdFlex="75">
            <router-view></router-view>
          </md-layout>
        </md-layout>
      </md-layout>
    </md-layout>

  </div>
</template>

<script>
  import Vue from 'vue'
  import AuthService from "../services/AuthService";
  import router from "../router/index";
  import loginInfoService from '../services/LoginInfoService'

  export default {

    data (){
      return {

      }
    },

    methods: {
      logout: function () {
        AuthService.removeToken();
        loginInfoService.removeLoginInfo()
        router.push({path: '/login'})
      }
    }

  }
</script>

<style>
  .space{
    margin-top: 5vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageScope.vue